import Banner from "../../images/banner.jpg";
import "./Shipping.css";
import Footer from "../Footer/Footer";
import NavBar from "../Layout/NavBar";

const Shipping = () => {
  const year = new Date().getFullYear();

  return (
    <div className="shipping-home">
      {/* Banner */}
      <div className="shipping-banner">
        <img src={Banner} alt="Shipping Banner" />
      </div>

      <NavBar />

      <div className="shipping-container">
        <h1>Shipping Policy</h1>
        <p className="updated-date">Last updated: {year}</p>

        <section>
          <h2>Order Processing</h2>
          <p>
            Orders are typically processed within <strong>2–3 business days</strong>.
            Processing times may be longer during holidays, sales, or high‑volume periods.
          </p>
        </section>

        <section>
          <h2>Shipping Times</h2>
          <p>
            Shipping times vary depending on your location and the carrier. Most orders
            within the United States arrive within <strong>3–7 business days</strong> after
            shipment.
          </p>
          <p>
            International shipping times vary and may take <strong>2–4 weeks</strong>
            depending on customs and regional carriers.
          </p>
        </section>

        <section>
          <h2>Shipping Costs</h2>
          <p>
            Shipping costs are calculated at checkout based on your location and the
            weight of your order. Any available shipping promotions or discounts will be
            applied automatically.
          </p>
        </section>

        <section>
          <h2>Tracking Information</h2>
          <p>
            When available, tracking numbers will be provided via email once your order
            has shipped. Some carriers may take up to 24 hours to update tracking
            information.
          </p>
        </section>

        <section>
          <h2>Lost or Delayed Packages</h2>
          <p>
            If your package is delayed, please allow additional time as carrier delays
            can occur. If your package appears lost, contact us and we will assist in
            filing a claim or locating the shipment.
          </p>
        </section>

        <section>
          <h2>Incorrect Addresses</h2>
          <p>
            Please ensure your shipping address is correct at checkout. We are not
            responsible for orders shipped to incorrectly entered addresses. If you
            notice an error, contact us immediately.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about this Shipping Policy, you can reach us at:
          </p>
          <p>
            <strong>https://flickerbound.com/contact</strong>
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Shipping;
